import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRefCallback } from '@tencent/glue-react-use';
import React, { useMemo, useRef, useState } from 'react';
import { CropControl as CropControlInner } from './CropControl';
import Crop from 'react-easy-crop';
import { useCropControl } from '../hooks/useCropControl';
import { calcZoom } from '../util';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
import { withAdpCombine } from '../../../config/context/config';
var CropControl = withAdpCombine(CropControlInner);
var cropStyle = {
  cropAreaStyle: {
    border: 'solid 2px #296BEF'
  }
};
export var ImageCrop = function ImageCrop(props) {
  var image = props.image,
    cropSizeConfig = props.cropSizeConfig,
    _props$scaleBase = props.scaleBase,
    scaleBase = _props$scaleBase === void 0 ? 420 : _props$scaleBase,
    style = props.style,
    _props$panelStyleConf = props.panelStyleConfig,
    panelStyleConfig = _props$panelStyleConf === void 0 ? {
      cropAreaWidth: 500,
      cropAreaHeight: 500,
      cropScaleBase: 420,
      cropControlWidth: 240,
      cropControlMargin: '0 0 0 40px'
    } : _props$panelStyleConf,
    _props$showDescriptio = props.showDescription,
    showDescription = _props$showDescriptio === void 0 ? true : _props$showDescriptio,
    _props$labelType = props.labelType,
    labelType = _props$labelType === void 0 ? 'px' : _props$labelType,
    _props$disableCropSiz = props.disableCropSizeConfig,
    disableCropSizeConfig = _props$disableCropSiz === void 0 ? [] : _props$disableCropSiz;
  var croppedValue = useRef([{
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }, {
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }]);
  var _useState = useState({
      x: 0,
      y: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    crop = _useState2[0],
    setCrop = _useState2[1];
  var mediaLoadedHandle = useRefCallback(props.onMediaLoaded);
  var _useCropControl = useCropControl({
      cropSizeConfig: cropSizeConfig,
      scaleBase: panelStyleConfig.cropScaleBase || scaleBase,
      imageValue: image,
      labelType: labelType,
      disableCropSizeConfig: disableCropSizeConfig
    }),
    cropScale = _useCropControl.cropScale,
    cropSizeIndex = _useCropControl.cropSizeIndex,
    ctrlDatasource = _useCropControl.ctrlDatasource,
    onSizeListChange = _useCropControl.onSizeListChange,
    cropSizeVal = _useCropControl.cropSizeVal,
    setCropSizeVal = _useCropControl.setCropSizeVal;
  var _useState3 = useState({
      min: 1,
      value: 1,
      max: 1
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    zoomState = _useState4[0],
    setZoomState = _useState4[1];
  var scaledCropSize = useMemo(function () {
    return {
      width: cropSizeVal.width * cropScale,
      height: cropSizeVal.height * cropScale
    };
  }, [cropScale, cropSizeVal]);
  var onCropComplete = useRefCallback(function (croppedArea, croppedAreaPixels) {
    var _a;
    croppedValue.current = [croppedArea, croppedAreaPixels];
    (_a = props.onCropComplete) === null || _a === void 0 ? void 0 : _a.call(props, croppedAreaPixels, cropSizeVal);
  });
  var onMediaLoaded = useRefCallback(function (mediaSize) {
    var width = mediaSize.width,
      height = mediaSize.height,
      naturalWidth = mediaSize.naturalWidth,
      naturalHeight = mediaSize.naturalHeight;
    var zoom = calcZoom({
      cropBoxSize: cropSizeVal,
      cropBoxScale: cropScale,
      imageBgSize: {
        width: width,
        height: height
      },
      imageNaturalSize: {
        width: naturalWidth,
        height: naturalHeight
      }
    });
    setZoomState(zoom);
    mediaLoadedHandle(mediaSize);
  });
  var cls = usePrefixCls('image-crop');
  return React.createElement("div", {
    className: cls,
    style: style
  }, showDescription && React.createElement("div", {
    className: "".concat(cls, "-desc")
  }, "\u68C0\u6D4B\u5230\u4E0A\u4F20\u7684\u56FE\u7247\u683C\u5F0F\u5927\u5C0F\u4E0D\u7B26\u5408\u89C4\u8303\uFF0C\u53EF\u8FDB\u884C\u88C1\u526A\u540E\u8FDB\u884C\u6295\u653E"), React.createElement("div", {
    className: "".concat(cls, "-content")
  }, React.createElement("div", {
    className: "".concat(cls, "-content-crop-content"),
    style: {
      width: panelStyleConfig.cropAreaWidth || 500,
      height: panelStyleConfig.cropAreaHeight || 500
    }
  }, React.createElement(Crop, {
    image: image.url,
    crop: crop,
    key: "".concat(cropSizeVal.width, "_").concat(cropSizeVal.height),
    minZoom: zoomState.min,
    maxZoom: zoomState.max,
    zoom: zoomState.value,
    cropSize: scaledCropSize,
    onCropChange: setCrop,
    style: cropStyle,
    showGrid: false,
    onMediaLoaded: onMediaLoaded,
    onCropComplete: onCropComplete
  })), React.createElement(CropControl, {
    style: {
      width: panelStyleConfig.cropControlWidth,
      margin: panelStyleConfig.cropControlMargin
    },
    value: cropSizeIndex,
    cropSize: cropSizeVal,
    onCropSizeChange: setCropSizeVal,
    datasource: ctrlDatasource,
    onValueChange: onSizeListChange,
    zoom: zoomState,
    fileName: image.name,
    onZoomChange: setZoomState,
    naturalSize: "".concat(image.width, " * ").concat(image.height, " px")
  })));
};